import React from "react";
import SearchIcon from "@material-ui/icons/Search";

export const GlobalFilter = ({ filter, setFilter, placeholder }) => {
  return (
    <div className="filter_input" style={{border:`${filter && filter !== "" ? "1px solid rgb(255, 255, 255)": "1px solid rgb(70, 70, 70)" }`}}>
      <SearchIcon className="search_icon" />
      <input
        //onChange={(e) => setInputSearch(e.target.value)}
        //value={inputSearch}
        placeholder={placeholder}
        type="text"
        value={filter || ""}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>
  );
};
